import { Box, Slider, Typography } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { COLOR_PRIMARY } from "../../../utils/styles";
import { setFilterPrice } from "../../../store";

function FilterPrice() {
  const dispatch = useDispatch();
  const value = useSelector((state) => state.filter.price) ?? 50; // Default to max when null
  return (
    <Box>
      <Typography
        level="body-md"
        sx={{
          textAlign: "left",
          "&::selection": {
            backgroundColor: COLOR_PRIMARY,
          },
        }}
      >
        Corkage Fee
      </Typography>
      <Slider
        color="neutral"
        valueLabelDisplay="on"
        value={value}
        defaultValue={50} // TOOD: somehow set to the max without triggering warning
        step={5}
        min={0}
        max={50}
        marks={[
          { value: 0, label: "Free" },
          { value: 25, label: "$25" },
          { value: 50, label: "$50+" },
        ]}
        onChange={(event, newValue) => {
          dispatch(setFilterPrice(newValue === 50 ? null : newValue));
        }}
      />
    </Box>
  );
}

export default FilterPrice;
